import Script from "next/script";

const Audigent = () => {
	// Disable ads during Cypress tests
	if (typeof window !== 'undefined' && (window as unknown as { Cypress?: unknown }).Cypress) {
		return null;
	}

	return (
		<Script
			id="audigent"
			strategy="afterInteractive"
			dangerouslySetInnerHTML={{
				__html: `
		(function(w,d,t,u){
  var a=d.createElement(t);a.async=1;a.src=u+"?url="+encodeURIComponent(w.location.href)+"&ref="+encodeURIComponent(d.referrer);
  var s=d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(a,s);
})(window, document, 'script', 'https://a.ad.gt/api/v1/u/matches/359')`,
			}}
		/>
	);
};

export default Audigent;
